import logo from '../assets/logo.png'
import logoCariacica from '../assets/logo-cariacica.png'
import logoSabara from '../assets/logo-sabara.png'
import logoItabirito from '../assets/logo-itabirito.png'
import logoSjdr from '../assets/logotipo-sjdr.png'

const baseInfo = { light: '#CFCFCF', main: '#7B7B7A', dark: '#585857' }
const baseText = { primary: '#585857', secondary: '#7B7B7A', disabled: '#CFCFCF' }
const baseError = { main: '#C23A22' }

const defaultTheme = {
  code: 'es',
  logo,
  title: 'Chamada Escolar - Secretaria de Educação',
  description:
    'Portal de incrição de alunos em escolas do estado do Espírito Santo - Chamada Escolar',
  favicon: '/favicon.ico',
  palette: {
    background: { paper: '#fffef9', default: '#f9f9f9' },
    primary: { light: '#5081A0', main: '#366C88', dark: '#365A6D' },
    secondary: { light: '#B16C73', main: '#9C5C6A', dark: '#7B4A55' },
    info: baseInfo,
    text: baseText,
    error: baseError,
  },
  coloredRadios: false,
}

const themes = {
  es: defaultTheme,
  cariacica: {
    ...defaultTheme,
    code: 'cariacica',
    logo: logoCariacica,
    title: 'Chamada Escolar - Cariacica',
    description:
      'Portal de incrição de alunos em escolas do cidade de Cariacica/ES - Chamada Escolar',
    favicon: '/favicon-cariacica.ico',
    palette: {
      background: { paper: '#fffef9', default: '#f7f7f7' },
      primary: { light: '#3bc4a4', main: '#38B598', dark: '#009D94' },
      secondary: { light: '#c5cca5', main: '#FAFFE1', dark: '#EEF3D8' },
      info: baseInfo,
      text: baseText,
      error: baseError,
    },
    coloredRadios: true,
  },
  sabara: {
    ...defaultTheme,
    code: 'sabara',
    logo: logoSabara,
    title: 'Chamada Escolar - Sabará',
    description:
      'Portal de incrição de alunos em escolas do município de Sabará/MG - Chamada Escolar',
    palette: {
      ...defaultTheme.palette,
      primary: { main: '#2D5183' },
      secondary: { main: '#2D5183' },
    },
  },
  itabirito: {
    ...defaultTheme,
    code: 'itabirito',
    logo: logoItabirito,
    title: 'Chamada Escolar - Itabirito',
    description:
      'Portal de incrição de alunos em escolas do município de Itabirito/MG - Chamada Escolar',
    palette: {
      ...defaultTheme.palette,
      primary: { light: '#4a6278', main: '#304053', dark: '#243040' },
      secondary: { main: '#304053' },
    },
  },
  sjdr: {
    ...defaultTheme,
    code: 'sjdr',
    logo: logoSjdr,
    title: 'Chamada Escolar - São João del Rei',
    description:
      'Portal de incrição de alunos em escolas do município de São João del Rei/MG - Chamada Escolar',
    palette: {
      ...defaultTheme.palette,
      primary: { light: '#6aa3de', main: '#4187d2', dark: '#336ba8' },
      secondary: { main: '#4187d2' },
    },
  },
}

const neutralTheme = {
  ...defaultTheme,
  code: null,
  logo: null,
  title: 'Chamada Escolar',
  description: 'Portal da Chamada Escolar',
  palette: {
    ...defaultTheme.palette,
    primary: { main: '#5F6B73' },
    secondary: { main: '#8A949B' },
  },
}

const present = value =>
  value !== null && value !== undefined && String(value).trim() !== ''

const HEX_COLOR = /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i

const colorOr = (value, fallback) => {
  if (!present(value) || !HEX_COLOR.test(String(value).trim())) return fallback

  const main = String(value).trim()

  return fallback && String(fallback.main).toLowerCase() === main.toLowerCase()
    ? fallback
    : { main }
}

const resolveTheme = (configTheme = null) => {
  if (!configTheme) return neutralTheme

  const base = themes[configTheme.code] || defaultTheme
  const pick = (field, fallback) =>
    present(configTheme[field]) ? configTheme[field] : fallback

  return {
    ...base,
    code: configTheme.code || base.code,
    title: pick('title', base.title),
    description: pick('description', base.description),
    logo: pick('logoUrl', base.logo),
    favicon: pick('faviconUrl', base.favicon),
    palette: {
      ...base.palette,
      primary: colorOr(configTheme.primaryColor, base.palette.primary),
      secondary: colorOr(configTheme.secondaryColor, base.palette.secondary),
    },
  }
}

const customer = { defaultTheme, neutralTheme, resolveTheme, themes }

export default customer
